import DirectionalButton from "../../components/DirectionalButton";

function Philosophy({ content }) {
  return (
    <section className="philosphy-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10" data-wow="fade-up">
            <p className="eybrow">
              <img
                className="star-icon"
                src="/assets/images/star.png"
                alt=""
                aria-hidden="true"
              />
              {content.eyebrow}
            </p>
            <h2 className="heading text-center">{content.description}</h2>
            <div className="btn-wrapper">
              <DirectionalButton href={content.ctaHref}>
                {content.ctaLabel} <i className="fa-solid fa-arrow-right" />
              </DirectionalButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Philosophy;
